
function uiReducer(state = {}, action = {} as any) {
  switch (action.type) {
    case 'UPDATE_HISTORY_INDEX':
      return {
        ...state,
        'historyIndex': action.payload.historyIndex
      }
    case 'USER_READ_TERMS_CONDITIONS':
      return {
        ...state,
        'userReadTermsAndConditions': action.payload.userReadTermsAndConditions
      }
    case 'UPDATE_BACK_LINK':
      return {
        ...state,
        'showBackLink': action.payload.showBackLink
      }
    default:
      return state;
  }
}

export default uiReducer;
